import React, { useEffect, useState } from "react";
import { FaLocationDot } from "react-icons/fa6";
import { MdDateRange } from "react-icons/md";
import { MdPeople } from "react-icons/md";
import { FaPen } from "react-icons/fa";
import { IoChevronBackOutline } from "react-icons/io5";
import moment from "moment";
import { useLocation, useNavigate } from "react-router-dom";
import Nav from "../NavBar/Nav";
import { Modal } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { PaymentInputsWrapper, usePaymentInputs } from "react-payment-inputs";
import images from "react-payment-inputs/images";
import Select from "react-select";

import { Controller, useForm } from "react-hook-form";
import { Country, State } from "country-state-city";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import axios from "axios";
import base_url from "../../api/bootapi";
import Swal from "sweetalert2";
import { IoIosCheckmarkCircle } from "react-icons/io";

const TravelInsurancePayment = () => {
  const location = useLocation();
  const [formData, setFormData] = useState(() => {
    const saved = localStorage.getItem("formData");
    return saved ? JSON.parse(saved) : null;
  });

  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [purchase, setPurchase] = useState(null);

  const [isPrimaryAddressChecked, setIsPrimaryAddressChecked] = useState(true);

  const [opened, { open, close }] = useDisclosure(false);
  const [succesOpened, { open: successOpen, close: successClose }] =
    useDisclosure(false);
  const customStyles = {
    control: (provided) => ({
      ...provided,
      backgroundColor: "white", // Input background
      borderColor: "#ccc",
      minHeight: "50px",
      boxShadow: "none",
      "&:hover": { borderColor: "#888" },
    }),
    menu: (provided) => ({
      ...provided,
      backgroundColor: "white", // Dropdown background
      zIndex: 9999,
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isFocused ? "#f0f0f0" : "white", // Hover effect
      color: "black",
      cursor: "pointer",
    }),
    singleValue: (provided) => ({
      ...provided,
      color: "black", // Selected value text color
    }),
    placeholder: (provided) => ({
      ...provided,
      color: "#888", // Placeholder text color
    }),
  };

  const [product, setProduct] = useState(() => {
    const saved = localStorage.getItem("product");
    return saved ? JSON.parse(saved) : null;
  });

  const {
    control,
    register,
    handleSubmit,
    watch,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      firstName: "",

      lastName: "",

      address: "",

      city: "",
      stateIsoCode: "",
      countryIsoCode: "",
      zipCode: "",
    },
  });

  const {
    wrapperProps,
    getCardImageProps,
    getCardNumberProps,
    getExpiryDateProps,
    getCVCProps,
  } = usePaymentInputs();

  // const [cardDetails, setCardDetails] = useState({
  //   card_number: null,
  //   card_expiry_month: null,
  //   card_expiry_year: null,
  //   card_cvv: null,
  // });

  // const handleChangeCard = (e) => {
  //   setCardDetails({
  //     ...cardDetails,
  //     card_number: e.target.value,
  //   });
  // };

  useEffect(() => {
    if (location.state) {
      setProduct(location.state);
      localStorage.setItem("product", JSON.stringify(location.state));
    }
  }, [location]);

  const onSubmit = (data) => {
    close();
    setLoading(true);

    const requestFormData = formData;

    const formatted = {
      ...requestFormData,
      destinations: requestFormData.destinations.map((d) => ({
        ...d,
        countryIsoCode: d.countryIsoCode?.value || "",
        stateIsoCode: d.stateIsoCode?.value || "",
      })),
      additionalTravelers: requestFormData.additionalTravelers.map(
        (traveler) => ({
          ...traveler,
          tripCost: Number(traveler.tripCost),
        })
      ),
    };

    if (
      !formatted.additionalTravelers ||
      formatted.additionalTravelers.length === 0
    ) {
      delete formatted.additionalTravelers;
    }

    formatted.agentId = "agent1234";
    const today = new Date().toISOString().split("T")[0];
    formatted.depositDate = today;

    if (formatted.primaryTraveler) {
      formatted.primaryTraveler = {
        ...formatted.primaryTraveler,
        tripCost: Number(formatted.primaryTraveler.tripCost) || 0,
        address: {
          ...formatted.primaryTraveler.address,
          countryIsoCode:
            formatted.primaryTraveler?.address?.countryIsoCode?.value || "",
          stateIsoCode:
            formatted.primaryTraveler?.address?.stateIsoCode?.value || "",
        },
      };

      // Top-level country/state if you need them
      // formatted.countryIsoCode =
      //   formatted.primaryTraveler.address.countryIsoCode;
      // formatted.stateIsoCode = formatted.primaryTraveler.address.stateIsoCode;
    }
    formatted.productCode = product?.productCode;

    function normalizeExpiry(expiry) {
      if (!expiry) return "";

      const [month, year] = expiry.split(" / ");

      // react-payment-inputs gives only last 2 digits
      const fullYear = `20${year}`;

      return { month, year: fullYear };
    }

    const { month, year } = normalizeExpiry(data.expiryDate);

    console.log(typeof month);
    const payments = [
      {
        amount: Number(product?.pricing?.premium),
        creditCard: {
          cardNumber: data.cardNumber,
          expirationMonth: Number(month),
          expirationYear: Number(year),
          cardVerificationValue: data?.cvc,
          firstName: data?.firstName,

          lastName: data?.lastName,
          addressLine1: data?.address,
          city: data?.city,
          stateIsoCode: data?.stateIsoCode?.value,
          countryIsoCode: data?.countryIsoCode?.value,
          zipCode: data?.zipCode,
        },
      },
    ];

    formatted.payments = payments;

    // delete formatted.primaryTraveler.address;
    // delete formatted.primaryTraveler.phoneNumbers;
    // delete formatted.primaryTraveler.email;

    console.log("Form Submitted:", formatted);

    axios
      .post(`${base_url.api1}/tourapp/travel_insurance/purchase`, formatted)
      .then(
        (response) => {
          console.log(response);
          setLoading(false);
          setPurchase(response?.data?.data?.data?.purchase);
          successOpen();
        },
        (error) => {
          // toast.error("User Not Created!");
          setLoading(false);
          // setTravelInsuranceData(null);

          Swal.fire({
            position: "center",
            width: "40rem",
            icon: "error",
            title: "Something went wrong!",
            showCloseButton: true,
            showConfirmButton: false,
          });
        }
      );
  };

  const selectedCountry = watch("countryIsoCode");
  const states = selectedCountry
    ? State.getStatesOfCountry(selectedCountry?.value).map((s) => ({
        value: s.isoCode,
        label: `${s.name}`,
      }))
    : [];

  const handleCheckboxChange = (e) => {
    console.log(e.target.checked);

    setIsPrimaryAddressChecked(e.target.checked);
  };

  useEffect(() => {
    if (isPrimaryAddressChecked) {
      console.log(formData);
      if (formData) {
        const primaryTraveler = formData?.primaryTraveler;
        const billingFormData = {
          firstName: primaryTraveler?.firstName,
          lastName: primaryTraveler?.lastName,

          address: primaryTraveler?.address?.addressLine1,
          city: primaryTraveler?.address?.city,
          zipCode: primaryTraveler?.address?.zipCode,
          stateIsoCode: primaryTraveler?.address?.stateIsoCode,
          countryIsoCode: primaryTraveler?.address?.countryIsoCode,
          cardNumber: "",
          expiryDate: "",
          cvc: "",
        };

        reset(billingFormData);
      }
    } else {
      reset({
        firstName: "",

        lastName: "",

        address: "",

        city: "",
        stateIsoCode: "",
        countryIsoCode: "",
        zipCode: "",
        cardNumber: "",
        expiryDate: "",
        cvc: "",
      });
    }
  }, [isPrimaryAddressChecked]);

  function handleDownloadAll() {
    const files = [
      { url: purchase.cobDownloadLink, name: "COB-Document.pdf" },
      { url: purchase.eobDownloadLink, name: "EOB-Document.pdf" },
    ];

    files.forEach((file) => {
      const link = document.createElement("a");
      link.href = file.url;
      link.setAttribute("download", file.name);
      document.body.appendChild(link);
      link.click();
      link.remove();
    });
  }

  function handleSuccessClose() {
    successClose();
    localStorage.removeItem("quote");
    localStorage.removeItem("product");
    localStorage.removeItem("formData");
    navigate("/insurance");
  }

  if (!formData) return <p>No data found</p>;

  return (
    <div className="insurance-payment-container">
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Nav />

      <Modal opened={opened} onClose={close} size={"lg"}>
        {/* Modal content */}
        <div className="billing-modal">
          <div className="billing-modal-header-wrapper">
            <h1>Payment</h1>
            <p>
              Please enter the name and address of the credit card holder below
            </p>
          </div>

          <div className="billing-checkbox-wrapper">
            <h1>Billing Contact</h1>{" "}
            <label>
              <input
                type="checkbox"
                onChange={handleCheckboxChange}
                checked={isPrimaryAddressChecked}
              />{" "}
              Use Primary Traveler Address
            </label>
          </div>

          <div className="billing-form">
            <form onSubmit={handleSubmit(onSubmit)}>
              {/* Primary Traveler */}
              <div className="traveler-wrapper">
                <div className="field-wrapper" style={{ marginBottom: "20px" }}>
                  <label>Card Details</label>
                  <PaymentInputsWrapper
                    {...wrapperProps}
                    className="custom-card-wrapper"
                  >
                    <svg {...getCardImageProps({ images })} />

                    {/* Card Number */}
                    <Controller
                      name="cardNumber"
                      control={control}
                      rules={{ required: "Card number is required" }}
                      render={({ field }) => (
                        <input
                          {...getCardNumberProps({
                            onChange: field.onChange,
                            onBlur: field.onBlur,
                            value: field.value,
                            className: "card-input",
                          })}
                        />
                      )}
                    />

                    {/* Expiry Date */}
                    <Controller
                      name="expiryDate"
                      control={control}
                      rules={{ required: "Expiry date is required" }}
                      render={({ field }) => (
                        <input
                          {...getExpiryDateProps({
                            onChange: field.onChange,
                            onBlur: field.onBlur,
                            value: field.value,
                            className: "card-input",
                          })}
                        />
                      )}
                    />

                    {/* CVC */}
                    <Controller
                      name="cvc"
                      control={control}
                      rules={{ required: "CVC is required" }}
                      render={({ field }) => (
                        <input
                          {...getCVCProps({
                            onChange: field.onChange,
                            onBlur: field.onBlur,
                            value: field.value,
                            className: "card-input",
                          })}
                        />
                      )}
                    />
                  </PaymentInputsWrapper>

                  {(errors?.cardNumber ||
                    errors?.cvv ||
                    errors?.expiryDate) && (
                    <p className="error-text">Please fill card details</p>
                  )}
                </div>

                <div className="field-grid-two">
                  <div className="field-wrapper">
                    <label>First Name</label>
                    <input {...register("firstName", { required: true })} />
                    {errors?.firstName && (
                      <p className="error-text">Required</p>
                    )}
                  </div>

                  <div className="field-wrapper">
                    <label>Last Name</label>
                    <input {...register("lastName", { required: true })} />
                    {errors?.lastName && <p className="error-text">Required</p>}
                  </div>
                </div>

                <div>
                  <div className="field-wrapper" style={{ marginTop: "15px" }}>
                    <label>Address </label>
                    <input
                      {...register("address", {
                        required: true,
                      })}
                    />
                    {errors?.address && <p className="error-text">Required</p>}
                  </div>

                  <div className="field-grid-two">
                    <div className="field-wrapper">
                      <label>City</label>
                      <input
                        {...register("city", {
                          required: true,
                        })}
                      />
                      {errors?.city && <p className="error-text">Required</p>}
                    </div>
                    <div className="field-wrapper">
                      <label>Zip Code</label>
                      <input
                        type="number"
                        {...register("zipCode", {
                          required: true,
                        })}
                      />
                      {errors?.zipCode && (
                        <p className="error-text">Required</p>
                      )}
                    </div>
                  </div>

                  <div className="destination-wrapper">
                    <div className="field-wrapper">
                      <label>Country</label>
                      <Controller
                        name={`countryIsoCode`}
                        control={control}
                        rules={{ required: true }}
                        render={({ field }) => (
                          <Select
                            {...field}
                            styles={customStyles}
                            options={Country.getAllCountries().map((c) => ({
                              value: c.isoCode,
                              label: c.name,
                            }))}
                            placeholder="Select Country"
                          />
                        )}
                      />
                      {errors?.countryIsoCode && (
                        <p className="error-text">Country is required</p>
                      )}
                    </div>

                    <div className="field-wrapper">
                      {/* State */}
                      <label>State</label>

                      <Controller
                        name={`stateIsoCode`}
                        control={control}
                        rules={{ required: true }}
                        render={({ field }) => (
                          <Select
                            {...field}
                            styles={customStyles}
                            options={states}
                            placeholder={
                              selectedCountry
                                ? "Select State"
                                : "Select country first"
                            }
                            isDisabled={!selectedCountry}
                          />
                        )}
                      />
                      {errors?.stateIsoCode && (
                        <p className="error-text">State is required</p>
                      )}
                    </div>
                  </div>
                </div>
              </div>

              {/* Submit */}
              <div style={{ marginTop: 20 }}>
                <button
                  type="submit"
                  className="insurance-submit-btn"
                  style={{ background: "#0bab44" }}
                >
                  Purchase
                </button>
              </div>
            </form>
          </div>
        </div>
      </Modal>

      <Modal
        opened={succesOpened}
        onClose={handleSuccessClose}
        closeOnClickOutside={false}
      >
        <div className="successful-modal">
          <div>
            <IoIosCheckmarkCircle size={"80px"} color="#0bab44" />
          </div>

          <h1>Payment Successfull</h1>

          <p>Plan Number : {purchase?.planNumber}</p>

          <button onClick={handleDownloadAll}>Download documents</button>
        </div>
      </Modal>
      <div className="insurance-payment-main">
        <div className="insurance-payment-left">
          <h1 className="insurance-payment-header">
            Complete Purchase Details
          </h1>

          <div>
            <h4 className="insurance-payment-quote-header">Quote Details</h4>
            <div className="traveler-payment-info-wrapper">
              <div className="traveler-info">
                <span className="traveler-info-icon-wrapper">
                  <FaLocationDot size={"18px"} color="#757575" />
                </span>

                <div className="traveler-info-title-wrapper">
                  <span className="traveler-info-title">Destinations</span>

                  <span className="traveler-info-data">
                    {formData?.destinations
                      ?.map((destination) => {
                        return (
                          destination.countryName
                        );
                      })
                      .join(",")}
                  </span>
                </div>
              </div>

              <div className="traveler-info">
                <span className="traveler-info-icon-wrapper">
                  <MdDateRange size={"18px"} color="#757575" />
                </span>

                <div className="traveler-info-title-wrapper">
                  <span className="traveler-info-title">Departure Date</span>

                  <span className="traveler-info-data">
                    {moment(formData?.departureDate).format("MM-DD-YYYY")}
                  </span>
                </div>
              </div>

              <div className="traveler-info">
                <span className="traveler-info-icon-wrapper">
                  <MdDateRange size={"18px"} color="#757575" />
                </span>

                <div className="traveler-info-title-wrapper">
                  <span className="traveler-info-title">Return Date</span>

                  <span className="traveler-info-data">
                    {moment(formData?.returnDate).format("MM-DD-YYYY")}
                  </span>
                </div>
              </div>

              <div className="traveler-info">
                <span className="traveler-info-icon-wrapper">
                  <MdPeople size={"18px"} color="#757575" />
                </span>

                <div className="traveler-info-title-wrapper">
                  <span className="traveler-info-title">Travelers Details</span>

                  <span className="traveler-info-data">
                    {formData?.additionalTravelers?.length + 1}{" "}
                    {formData?.additionalTravelers?.length === 0
                      ? " Traveler"
                      : " Travelers"}
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div style={{ marginTop: "50px" }}>
            <h4 className="insurance-payment-quote-header">Traveler Details</h4>

            <h6 className="insurance-payment-quote-sub-header">
              Primary Traveler
            </h6>
            <div className="payment-row">
              <div className="traveler-info">
                <div className="traveler-info-title-wrapper">
                  <span className="traveler-info-title">First Name</span>

                  <span className="traveler-info-data">
                    {formData?.primaryTraveler?.firstName}
                  </span>
                </div>
              </div>

              {/* <div className="traveler-info">
                <div className="traveler-info-title-wrapper">
                  <span className="traveler-info-title">First Name</span>

                  <span className="traveler-info-data">
                    {formData?.primaryTraveler?.firstName}
                  </span>
                </div>
              </div> */}

              <div className="traveler-info">
                <div className="traveler-info-title-wrapper">
                  <span className="traveler-info-title">Middle Name</span>

                  <span className="traveler-info-data">
                    {formData?.primaryTraveler?.middleName}
                  </span>
                </div>
              </div>

              <div className="traveler-info">
                <div className="traveler-info-title-wrapper">
                  <span className="traveler-info-title">Last Name</span>

                  <span className="traveler-info-data">
                    {formData?.primaryTraveler?.lastName}
                  </span>
                </div>
              </div>
            </div>

            <div className="payment-row">
              <div className="traveler-info">
                <div className="traveler-info-title-wrapper">
                  <span className="traveler-info-title">Date of Birth</span>

                  <span className="traveler-info-data">
                    {moment(formData?.primaryTraveler?.dateOfBirth).format(
                      "MM-DD-YYYY"
                    )}
                  </span>
                </div>
              </div>

              <div className="traveler-info">
                <div className="traveler-info-title-wrapper">
                  <span className="traveler-info-title">Email</span>

                  <span className="traveler-info-data">
                    {formData?.primaryTraveler?.email}
                  </span>
                </div>
              </div>

              <div className="traveler-info">
                <div className="traveler-info-title-wrapper">
                  <span className="traveler-info-title">Phone Number</span>

                  <span className="traveler-info-data">
                    {formData?.primaryTraveler?.phoneNumbers}
                  </span>
                </div>
              </div>

              <div className="traveler-info">
                <div className="traveler-info-title-wrapper">
                  <span className="traveler-info-title">Trip Cost</span>

                  <span className="traveler-info-data">
                    ${formData?.primaryTraveler?.tripCost}
                  </span>
                </div>
              </div>
            </div>

            <div>
              <div className="traveler-info" style={{ marginTop: "15px" }}>
                <div className="traveler-info-title-wrapper">
                  <span className="traveler-info-title">Address Line 1</span>

                  <span className="traveler-info-data">
                    {formData?.primaryTraveler?.address?.addressLine1}
                  </span>
                </div>
              </div>

              <div className="traveler-info" style={{ marginTop: "15px" }}>
                <div className="traveler-info-title-wrapper">
                  <span className="traveler-info-title">Address Line 2</span>

                  <span className="traveler-info-data">
                    {formData?.primaryTraveler?.address?.addressLine2}
                  </span>
                </div>
              </div>

              <div className="payment-row">
                <div className="traveler-info">
                  <div className="traveler-info-title-wrapper">
                    <span className="traveler-info-title">City</span>

                    <span className="traveler-info-data">
                      {formData?.primaryTraveler?.address?.city}
                    </span>
                  </div>
                </div>

                <div className="traveler-info">
                  <div className="traveler-info-title-wrapper">
                    <span className="traveler-info-title">State</span>

                    <span className="traveler-info-data">
                      {formData?.primaryTraveler?.address?.stateIsoCode?.label}
                    </span>
                  </div>
                </div>

                <div className="traveler-info">
                  <div className="traveler-info-title-wrapper">
                    <span className="traveler-info-title">Country</span>

                    <span className="traveler-info-data">
                      {
                        formData?.primaryTraveler?.address?.countryIsoCode
                          ?.label
                      }
                    </span>
                  </div>
                </div>

                <div className="traveler-info">
                  <div className="traveler-info-title-wrapper">
                    <span className="traveler-info-title">Zip Code</span>

                    <span className="traveler-info-data">
                      {formData?.primaryTraveler?.address?.zipCode}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {formData?.additionalTravelers &&
            formData?.additionalTravelers.length > 0 && (
              <div style={{ marginTop: "50px" }}>
                <h6 className="insurance-payment-quote-sub-header">
                  Additional Traveler
                </h6>

                {formData?.additionalTravelers?.map((traveler, index) => {
                  return (
                    <div className="payment-row">
                      <div className="traveler-info">
                        <div className="traveler-info-title-wrapper">
                          <span className="traveler-info-title">
                            First Name
                          </span>

                          <span className="traveler-info-data">
                            {traveler?.firstName}
                          </span>
                        </div>
                      </div>

                      <div className="traveler-info">
                        <div className="traveler-info-title-wrapper">
                          <span className="traveler-info-title">Last Name</span>

                          <span className="traveler-info-data">
                            {traveler?.lastName}
                          </span>
                        </div>
                      </div>

                      <div className="traveler-info">
                        <div className="traveler-info-title-wrapper">
                          <span className="traveler-info-title">
                            Date of Birth
                          </span>

                          <span className="traveler-info-data">
                            {moment(traveler?.dateOfBirth).format("MM-DD-YYYY")}
                          </span>
                        </div>
                      </div>
                      <div className="traveler-info">
                        <div className="traveler-info-title-wrapper">
                          <span className="traveler-info-title">Trip Cost</span>

                          <span className="traveler-info-data">
                            ${traveler?.tripCost}
                          </span>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            )}
        </div>

        <div  className="payment-box-wrapper">
          <div className="payment-box">
            <h1 className="payment-header">Quote Summary</h1>

            <hr />

            <div className="payment-plan-title-wrapper">
              <h5>Worldwide Trip Protector Platinum</h5>{" "}
              <span>(2 Travelers)</span>
            </div>

            <div>
              {product?.pricing?.travelerBreakdown?.map((priceItem, index) => {
                return (
                  <div className="payment-traveler">
                    <div className="payment-traveler-header">
                      {index === 0 ? "Primary Traveler" : `Companion ${index}`}
                    </div>

                    {priceItem?.pricingDetail?.map((planCoverage, index) => {
                      return (
                        <div className="payment-plan-price">
                          <span>
                            {planCoverage?.productCoverageDescription}
                          </span>

                          <span>${planCoverage?.price}</span>
                        </div>
                      );
                    })}
                  </div>
                );
              })}

              <div className="total-product-price">
                <div className="total-product-price-header-wrapper">
                  <span>Total Plan Cost</span>

                  <span>${product?.pricing?.premium}</span>
                </div>
                <button onClick={open}>Purchage</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TravelInsurancePayment;
